import { defineMessages } from 'react-intl';

const messages = defineMessages({
  placeholder: '请输入单号/项目名称',
});

export default messages;
